import api from './api';

export const mediaService = {
    uploadImage: async (file) => {
        const { data } = await api.post('/user/media/upload-url', {
            contentType: file.type,
            fileSize: file.size
        });

        const response = await fetch(data.uploadUrl, {
            method: 'PUT',
            headers: data.headers,
            body: file
        });
        if (!response.ok) throw new Error('Échec de l’envoi de l’image vers R2');

        return { photoUrl: data.photoUrl, objectKey: data.objectKey };
    },

    deleteImage: (objectKey) => api.delete('/user/media', { data: { objectKey } })
};
